<template>
	<v-dialog ref="vDialogWrapper" v-bind="$attrs" v-on="$listeners">
		<slot></slot>
	</v-dialog>
</template>

<script>
/**
 * This is a wrapper component for the Vuetify v-dialog component designed to add support
 * for 508 accessibility.
 *
 * It keeps pressing tab or shift-tab to stay within the wrapper
 */
export default {
	name: 'DialogWrapper',
	inheritAttrs: false,
	props: {
		dialogW: Boolean
	},
	watch: {
		dialogW: function (newValue, oldValue) {
			if (newValue !== oldValue) {
			}
		}
	},
	updated () {
		var vDialog = document.getElementsByClassName('v-dialog__content v-dialog__content--active');
		const me = this;
		for (var j = 0; j < vDialog.length; j++) {
			vDialog[j].addEventListener('keydown', function (e) {
				me.trapFocus(this, e);
			});
		}
	},
	methods: {
		trapFocus: function (dialog, e) {
			var KEY_TAB = 9;
			var focusableEls = Array.prototype.slice.call(dialog.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex='0']"));
			var firstFocusableEl = focusableEls[0];
			var lastFocusableEl = focusableEls[focusableEls.length - 1];
			switch (e.keyCode) {
			case KEY_TAB:
				if (focusableEls.length === 1) {
					e.preventDefault();
					break;
				}
				if (e.shiftKey) {
					handleBackwardTab();
				} else {
					handleForwardTab();
				}
				break;
			default:
				break;
			}
			function handleBackwardTab () {
				if (document.activeElement === firstFocusableEl) {
					e.preventDefault();
					lastFocusableEl.focus();
				}
			}
			function handleForwardTab () {
				if (document.activeElement === lastFocusableEl) {
					e.preventDefault();
					firstFocusableEl.focus();
				}
			}
		}
	}
}
</script>

<style scoped>

</style>
